import Contentful from 'contentful'
import { TypeComponentCtaButton } from './component-cta-button'
import { TypeVariationContainerAuthAndDeviceTypeCta } from '@lib/types/variation-container-auth-and-device-type-cta'
import * as CFRichTextTypes from '@contentful/rich-text-types'
import { TypeItemFeatureHighlight } from './item-feature-highlight'

export enum ContentfulPlanComparisonType {
  Free = 'free',
  Pro = 'pro',
  Enterprise = 'enterprise',
}

export interface TypeComponentPlanItemFields {
  internalName: Contentful.EntryFields.Symbol
  planType: ContentfulPlanComparisonType
  monthlyPrice: Contentful.EntryFields.Number
  monthlyPriceLabel: Contentful.EntryFields.Text
  monthlyPricePerMonth: Contentful.EntryFields.Number
  monthlyPricePerMonthLabel: Contentful.EntryFields.Symbol
  eyebrow: Contentful.EntryFields.Text
  title: Contentful.EntryFields.Text
  description: CFRichTextTypes.Document
  features: Contentful.EntryFields.Text[]
  cta: TypeComponentCtaButton | TypeVariationContainerAuthAndDeviceTypeCta
}

export interface TypeComponentPlansModuleFields {
  internalName: Contentful.EntryFields.Symbol
  heading: TypeItemFeatureHighlight
  savingsLabel: Contentful.EntryFields.Text
  plans: Contentful.Entry<TypeComponentPlanItemFields>[]
}

export type TypeComponentPlansModule = Contentful.Entry<TypeComponentPlansModuleFields>
